export default "__VITE_ASSET__DOIhw_mZ__"